import '../containers/css/LoadingSpinner.css'

import React from 'react'

export const LoadingSpinner = () => <div data-testid="loading-spinner" className="spin-box"></div>
